import { useEffect, useState } from "react";
import { faqPageData } from "../../Blc_Api/BlcFaqPageData/BlcFaqPageData";






export function useBlcFaqPageData() {
    const [faqData,setFaqPageData] = useState();
    
    useEffect(()=>{
        faqPageData().then(response=>{
            setFaqPageData(response);
        });
    },[]);

    return[faqData,setFaqPageData];
}